export const formatFullName = <T extends { firstName?: string; lastName?: string }>(person: T) =>
  person?.firstName || person?.lastName ? `${person?.firstName ?? ""} ${person?.lastName ?? ""}` : "-";
